enum SectorProposalsStatic {
  /**
   * @method GET
   * @description Listar solicitudes de creación de sectores
   */
  list = "/v3/admin/sector-proposals",
  /**
   * @method POST
   * @description Crear solicitud de creación de sector
   */
  create = "/v3/admin/sector-proposals"
}

const SectorProposalsDynamic = {
  detail: (proposal: string | number) => `/v3/admin/sector-proposals/${proposal}`,
  approve: (proposal: string | number) =>
    `/v3/admin/sector-proposals/${proposal}/approve`,
  reject: (proposal: string | number) =>
    `/v3/admin/sector-proposals/${proposal}/reject`
};

export const SectorProposalsEndpoints = {
  ...SectorProposalsStatic,
  ...SectorProposalsDynamic
};

export type SectorProposalsEndpoints = typeof SectorProposalsEndpoints;

